export const menuOptions = [
  {
    label: "Agente Cobrador",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/agente-cobrador",
  },
  {
    label: "Centro de Custo",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/centro-de-custo",
  },
  {
    label: "Conta Corrente",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/conta-corrente",
  },
  {
    label: "Despesa",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/despesa",
  },
  {
    label: "Estabelecimento",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/estabelecimento",
  },
  {
    label: "Fornecedores",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/fornecedor",
  },
  {
    label: "Plano Contas",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/plano-contas",
  },
  {
    label: "Tipo de Doc.",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/tipo-de-documento",
  },
  {
    label: "Tipo de Fornec.",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/tipo-de-fornecedor",
  },

  {
    label: "Tipo Pagamento",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/tipo-pagamento",
  },
  {
    label: "Lançamentos",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/lancamento",
  },
  {
    label: "Consulta de Contas",
    category: "Contas a Pagar",
    path: "/contas-a-pagar/consulta",
  },
];
